<template>
  <div class="container">

    <template>

      <div class="top-row">
        <h3>Share via WhatsApp Push</h3>
        <p>Add phone numbers to send later</p>
        <button v-if="is_show_more_respondents" @click="hideAddMoreRespondents" class="back-to-list-btn">Back to List</button>
      </div>

      <div class="upload-container">
        <textarea
        placeholder="Paste phone numbers here"
        v-model="pasted_input"></textarea>
        <div class="drop-container">
          <p class="folder-emoji">🗂️</p>
          <label class="upload-file-btn" @click="removeFile">
            {{ !csv_name ? 'Browse Files' : `Remove ${csv_name}`}}
            <input v-if="!csv_name" @change="uploadCSV($event)" type="file" ref="file" accept=".xlsx, .xls, .csv" />
          </label>
          <p>Files Supported: XLS, CSV</p>
        </div>
      </div>

      <p class="format-warning">*Please include country code & separate with commas or rows</p>

      <template v-if="parsed_pushes.length && !is_adding_numbers">
        <a-button @click="addNumbers" class="add-numbers-btn">Add Numbers ({{ parsed_pushes.length }})</a-button>
        <button @click="clearNumbers" class="clear-btn">Clear</button>
      </template>

      <a-spin v-if="is_adding_numbers" class="spinner">
        <a-icon slot="indicator" type="loading" style="font-size: 40px; color: #1BD285;" spin />
      </a-spin>

    </template>

  </div>
</template>

<script>

import moment from 'moment';
import { parser } from '../../services/parser.js';
import readXlsxFile from 'read-excel-file'

export default {
  name: 'WhatsappUpload',
  props: {
    is_show_more_respondents: Boolean
  },
  data() {
    return {
      pasted_input: '',
      csv_name: '',
      csv_content: '',
      csv_entries_with_survey_vars: [],
      is_adding_numbers: false
    }
  },

  computed: {

    parsed_pushes() {

      let push_arr = [];

      // Get phone numbers from pasted input in textarea
      let tokens = this.pasted_input.replace(/\n/g, ",").split(","); // Replace new lines with commas, then split on commas

      for (let token of tokens) {
        let phone_number = String(parser.extractNumber(token.replace(/-|\s/g,""))); // Remove spaces and dashes from text
        if (phone_number.length >= 8 && phone_number.length <= 15) {
          push_arr.push({ phone_number });
        };
      };

      // Get phone numbers from uploaded file content (with just phone numbers, no headers)
      let csv_tokens = this.csv_content.replace(/\n/g, ",").split(",");
      for (let token of csv_tokens) {
        let phone_number = String(parser.extractNumber(token));
        if (phone_number.length >= 8 && phone_number.length <= 15) {
          push_arr.push({ phone_number });
        };
      };

      // Get phone numbers and survey_vars from parsed CSV with survey_vars headers
      for (let entry of this.csv_entries_with_survey_vars) {
        if (entry.phone_number) {
          let phone_number = String(parser.extractNumber(entry.phone_number));
          if (phone_number.length >= 8 && phone_number.length <= 15) {
            let push = { phone_number: entry.phone_number };
            _.forEach(entry, (value, key) => {
              if (key && key !== 'phone_number') {
                if (!push.survey_vars) {
                  push.survey_vars = {};
                };
                push.survey_vars[key] = value;
              };
            });
            push_arr.push(push);
          };
        }

      };

      return push_arr;

    },

    invalid_phone_numbers() {
      let invalid_count = 0;
      let tokens = this.pasted_input.split(',');
      for (let token of tokens) {
        if (token.length <= 8 || token.length > 15) {
          invalid_count++;
        };
      };
      return invalid_count;
    },

    survey() {
      let survey_index = this.$route.params.survey_index;
      let surveys = this.$store.state.surveys;
      return surveys ? surveys[survey_index] : null;
    }

  },

  methods: {

    uploadCSV(e) {

      const file = e.target.files[0];

      if (file.name && file.name.includes('.xls')) {

        let xlx_content = '';
        readXlsxFile(file).then((rows) => {
          for (let row of rows) {
            for (let cell of row) {
              if (!xlx_content) {
                xlx_content = cell;
              } else {
                xlx_content += ',';
                xlx_content += cell;
              };
            };
          };
          this.csv_content = xlx_content;
          this.csv_name = file.name;
        })


      // Denote that a CSV contains named survey_vars to include if the name include 'vars'
      } else if (file.name && file.name.includes('vars')) {

        let that = this;
        this.$papa.parse(file, {
          header: true,
          complete: function(results) {
            if (results.data[0]) {
              let headers = _.keys(results.data[0]);
              that.$notification.open({
                message: `${headers.length} CSV headers detected`,
                description: `Headers: ${headers.join(', ')}`,
                placement: 'bottomLeft',
                duration: 6.5
              });
            };
            that.csv_entries_with_survey_vars = results.data;
    	     }
        });

      } else {

        const reader = new FileReader();
        reader.onload = (e) => {
          this.csv_content = e.target.result;
          this.csv_name = file.name;
          console.log('this.csv_name', this.csv_name);
        };
        reader.readAsText(file);

      }

    },

    removeFile(e) {
      if (this.csv_name) {
        this.csv_content = '';
        this.csv_name = '';
        e.preventDefault();
      };
    },

    addNumbers() {
      this.is_adding_numbers = true;
      let survey_index = this.$route.params.survey_index;
      this.$store.dispatch('queueWhatsappPushes', { survey_index, pushes: this.parsed_pushes });
      analytics.track('Distribute Add Numbers', { survey_id: this.survey.id, count: this.parsed_pushes.length });
      setTimeout(() => {
        this.$emit('hideAddMoreRespondents');
      }, 2500);
    },

    clearNumbers() {
      this.csv_name = '';
      this.csv_content = '';
      this.pasted_input = '';
    },

    hideAddMoreRespondents() {
      this.$emit('hideAddMoreRespondents');
    },

  }
}
</script>

<style scoped lang="scss">

.container{
  width: 80%;
  background-color: white;
  border: 1px solid rgb(216,216,216);
  border-radius: 6px;
  padding-bottom: 30px;
}

.top-row{
  padding-top: 25px;
  position: relative;

  h3{
    font-size: 16px;
    font-weight: 600;
    width: 250px;
    margin: 0 auto;
    margin-top: 8px;
    background-size: 25px;
    background-position: right;
    background-repeat: no-repeat;
    background-image: url("../../assets/whatsapp-logo.svg");
  }

  p{
    text-align: center;
    margin-top: 15px;
    font-weight: 500;
  }

  &.upgrade{
    p{
      font-size: 16px;
      margin-top: 20px;
      line-height: 28px;
      &:first-of-type{
        margin-top: 30px;
        font-weight: 600;
      }
      &:last-of-type{
        margin-bottom: 30px;
      }
    }
  }

  .back-to-list-btn{
    position: absolute;
      top: 30px;
      left: 30px;
    padding-left: 20px;
    font-size: 14px;
    font-weight: 600;
    border: none;
    background-color: transparent;
    background-size: 10px;
    background-position: 0px 3px;
    background-repeat: no-repeat;
    background-image: url("../../assets/icons/back-to-push-list-arrow.svg");
    opacity: .8;
    transition: all 0.1s ease;
    cursor: pointer;
    &:hover{
      opacity: 1;
    }
    &:focus{
      outline: none;
    }

  }

}

.upload-container{
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
  padding-right: 30px;
  padding-left: 30px;
  & > *{
    width: 48.5%;
  }
  textarea{
    background-color: rgb(245,245,245);
    border: 1px solid rgb(225,225,225);
    border-radius: 4px;
    padding: 12px;
  }
  .drop-container{
    border: 1px solid rgb(200,200,200);
    border-style: dashed;
    border-radius: 4px;
    padding-top: 40px;
    padding-bottom: 40px;
    p{
      text-align: center;
      margin: 0px;
      cursor: default;
    }
    .folder-emoji{
      font-size: 28px;
      opacity: 1;
    }
    input[type="file"] {
      display: none;
    }
    .upload-file-btn{
      text-align: center;
      display: block;
      //margin: 0 auto;
      margin-top: 5px;
      margin-bottom: 10px;
      color: #01A2FF;
      opacity: .85;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.1s ease;
      &:hover{
        opacity: 1;
      }
    }
    .browse-btn{
      color: #01A2FF;
      font-weight: 600;
      margin-top: 5px;
      margin-bottom: 10px;
    }
  }
}


.format-warning{
  text-align: center;
  margin-top: 20px;
  margin-bottom: 40px;
}

.add-numbers-btn{
  font-size: 14px;
  font-weight: 600;
  color: white;
  height: 39px;
  background: -moz-linear-gradient(top, #2c3052 0%, #1e2032 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(top, #2c3052 0%,#1e2032 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom, #2c3052 0%,#1e2032 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  padding: 0px 13px 1px 13px;
  display: block;
  margin: 0 auto;
  margin-top: 20px;
  opacity: .95;
  border-radius: 6px;
  border: 1px solid black;
  box-shadow: 0 0 3px 0 rgba(0,0,0,.05);
  transition: all 0.3s ease;
  cursor: pointer;
  &:hover{
    opacity: 1;
    background-color: rgb(250,250,250);
  }
}

.clear-btn{
  background: transparent;
  border: none;
  display: block;
  margin: 0 auto;
  margin-top: 20px;
  font-weight: 500;
}

.spinner{
  display: block;
  margin: 0 auto;
  margin-bottom: 30px;
  transform: translateX(-10px);
}




</style>
